!function (t, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports.loom = r() : t.loom = r();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    var r = {};

    function e(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    return e.m = t, e.c = r, e.d = function (t, r, n) {
      e.o(t, r) || Object.defineProperty(t, r, {
        enumerable: !0,
        get: n
      });
    }, e.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, e.t = function (t, r) {
      if (1 & r && (t = e(t)), 8 & r) return t;
      if (4 & r && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (e.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & r && "string" != typeof t) for (var o in t) {
        e.d(n, o, function (r) {
          return t[r];
        }.bind(null, o));
      }
      return n;
    }, e.n = function (t) {
      var r = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(r, "a", r), r;
    }, e.o = function (t, r) {
      return Object.prototype.hasOwnProperty.call(t, r);
    }, e.p = "", e(e.s = 12);
  }([, function (t, r, e) {
    t.exports = e(14);
  }, function (t, r, e) {
    "use strict";

    e.d(r, "d", function () {
      return o;
    }), e.d(r, "c", function () {
      return i;
    }), e.d(r, "b", function () {
      return c;
    }), e.d(r, "a", function () {
      return a;
    });
    var n = "(?:https?://)?((?:stage.loom.com|loom.com|www.loom.com|loomlocal.com:4444)/share/[a-f0-9]+)",
        o = new RegExp("^".concat(n, "$")),
        i = new RegExp("".concat(n), "g"),
        c = /(www\.loom\.com|loom\.com|stage\.loom\.com|loomlocal\.com:4444)/i,
        a = "lo-link-replaced";
  }, function (t, r) {
    t.exports = function (t, r, e) {
      return r in t ? Object.defineProperty(t, r, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[r] = e, t;
    };
  }, function (t, r) {
    function e(t, r, e, n, o, i, c) {
      try {
        var a = t[i](c),
            u = a.value;
      } catch (t) {
        return void e(t);
      }

      a.done ? r(u) : Promise.resolve(u).then(n, o);
    }

    t.exports = function (t) {
      return function () {
        var r = this,
            n = arguments;
        return new Promise(function (o, i) {
          var c = t.apply(r, n);

          function a(t) {
            e(c, o, i, a, u, "next", t);
          }

          function u(t) {
            e(c, o, i, a, u, "throw", t);
          }

          a(void 0);
        });
      };
    };
  },,,,,,, function (t, r, e) {
    var n = e(18),
        o = e(19),
        i = e(20);

    t.exports = function (t, r) {
      return n(t) || o(t, r) || i();
    };
  }, function (t, r, e) {
    "use strict";

    e.r(r);

    var n = e(1),
        o = e.n(n),
        i = e(4),
        c = e.n(i),
        a = e(13),
        u = e.n(a),
        f = e(3),
        l = e.n(f),
        s = e(11),
        h = e.n(s),
        p = e(2),
        d = function d(t) {
      return p.d.test(t);
    },
        y = function y(t) {
      return d(t);
    },
        v = function v(t) {
      return "A" === t.nodeName && !t.className.includes(p.a) && y(t.href);
    },
        m = {
      isLoomUrl: d
    };

    function g(t, r) {
      var e = Object.keys(t);
      return Object.getOwnPropertySymbols && e.push.apply(e, Object.getOwnPropertySymbols(t)), r && (e = e.filter(function (r) {
        return Object.getOwnPropertyDescriptor(t, r).enumerable;
      })), e;
    }

    var w = /src=["']+(https?:\/\/[a-zA-z\d:\.\/?&]+)/,
        b = function b(t, r) {
      var e = r.width,
          n = r.height,
          o = t.width,
          i = t.height;
      if (e || n) return t;
      var c,
          a,
          u,
          f,
          s = t.html.match(w),
          p = h()(s, 2)[1];
      return function (t) {
        for (var r = 1; r < arguments.length; r++) {
          var e = null != arguments[r] ? arguments[r] : {};
          r % 2 ? g(e, !0).forEach(function (r) {
            l()(t, r, e[r]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : g(e).forEach(function (r) {
            Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
          });
        }

        return t;
      }({}, t, {
        html: (c = p, a = i / o, u = "".concat(100 * a, "%"), f = "position: relative; padding-bottom: ".concat(u, "; height: 0;"), '<div class="lo-emb-vid" style="'.concat(f, '"><iframe src="').concat(c, '" ') + 'frameborder="0" webkitallowfullscreen mozallowfullscreen ' + 'allowfullscreen style="'.concat("position: absolute; top: 0; left: 0; width: 100%; height: 100%;", '"></iframe></div>'))
      });
    },
        x = function x(t, r) {
      if (d(t)) return function (t, r) {
        var e = r.width,
            n = r.height,
            o = e ? "&maxwidth=".concat(e) : "",
            i = n ? "&maxheight=".concat(n) : "",
            c = t.match(p.b),
            a = h()(c, 1)[0],
            u = a;
        return "loom.com" === a && (u = "www.".concat(a)), "https://".concat(u, "/v1/oembed?url=").concat(t).concat(o).concat(i);
      }(t, r);
      throw new Error("URL is not from a supported video provider");
    },
        O = function O(t) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          e = y(t);
      if (e) return fetch(x(t, r)).then(function (t) {
        return t.json();
      }).then(function (t) {
        return b(t, r);
      }).catch(function () {
        throw new Error("Unable to fetch oembed data");
      });
      throw new Error("URL is not from a supported video provider");
    },
        j = function j(t, r) {
      var e,
          n,
          o = (e = r, (n = document.createElement("div")).innerHTML = e, n.firstChild);
      t.parentNode.insertBefore(o, t);
    },
        E = function E() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "a",
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : document,
          n = u()(e.querySelectorAll(t));
      n.filter(v).forEach((i = c()(o.a.mark(function t(e) {
        var n, i;
        return o.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, O(e.href, r);

              case 2:
                return n = t.sent, i = n.html, j(e, i), e.className = "".concat(e.className, " ").concat(p.a), t.abrupt("return", !0);

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t);
      })), function (t) {
        return i.apply(this, arguments);
      }));
      var i;
    };

    function L(t, r) {
      var e = Object.keys(t);
      return Object.getOwnPropertySymbols && e.push.apply(e, Object.getOwnPropertySymbols(t)), r && (e = e.filter(function (r) {
        return Object.getOwnPropertyDescriptor(t, r).enumerable;
      })), e;
    }

    function P(t) {
      for (var r = 1; r < arguments.length; r++) {
        var e = null != arguments[r] ? arguments[r] : {};
        r % 2 ? L(e, !0).forEach(function (r) {
          l()(t, r, e[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : L(e).forEach(function (r) {
          Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
        });
      }

      return t;
    }

    var _ = function _(t) {
      var r = t.match(p.d),
          e = h()(r, 2)[1];
      return {
        originalUrl: t,
        requestUrl: "https://".concat(e)
      };
    },
        S = function () {
      var t = c()(o.a.mark(function t(r, e) {
        var n, i, a, u;
        return o.a.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (i = (n = r || "").match(p.c)) {
                  t.next = 4;
                  break;
                }

                return t.abrupt("return", n);

              case 4:
                return a = i.map(_).map(function () {
                  var t = c()(o.a.mark(function t(r) {
                    var n, i;
                    return o.a.wrap(function (t) {
                      for (;;) {
                        switch (t.prev = t.next) {
                          case 0:
                            return t.next = 2, O(r.requestUrl, e);

                          case 2:
                            return n = t.sent, i = n.html, t.abrupt("return", P({}, r, {
                              embedCode: i
                            }));

                          case 5:
                          case "end":
                            return t.stop();
                        }
                      }
                    }, t);
                  }));
                  return function (r) {
                    return t.apply(this, arguments);
                  };
                }()), t.next = 7, Promise.all(a);

              case 7:
                return u = t.sent, t.abrupt("return", u.reduce(function (t, r) {
                  var e = r.originalUrl,
                      n = r.embedCode,
                      o = new RegExp(e, "g");
                  return t.replace(o, n);
                }, n));

              case 9:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }));
      return function (r, e) {
        return t.apply(this, arguments);
      };
    }();

    e.d(r, "oembed", function () {
      return O;
    }), e.d(r, "linkReplace", function () {
      return E;
    }), e.d(r, "textReplace", function () {
      return S;
    }), e.d(r, "validate", function () {
      return m;
    });
  }, function (t, r, e) {
    var n = e(15),
        o = e(16),
        i = e(17);

    t.exports = function (t) {
      return n(t) || o(t) || i();
    };
  }, function (t, r, e) {
    var n = function (t) {
      "use strict";

      var r,
          e = Object.prototype,
          n = e.hasOwnProperty,
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          c = o.asyncIterator || "@@asyncIterator",
          a = o.toStringTag || "@@toStringTag";

      function u(t, r, e, n) {
        var o = r && r.prototype instanceof y ? r : y,
            i = Object.create(o.prototype),
            c = new _(n || []);
        return i._invoke = function (t, r, e) {
          var n = l;
          return function (o, i) {
            if (n === h) throw new Error("Generator is already running");

            if (n === p) {
              if ("throw" === o) throw i;
              return k();
            }

            for (e.method = o, e.arg = i;;) {
              var c = e.delegate;

              if (c) {
                var a = E(c, e);

                if (a) {
                  if (a === d) continue;
                  return a;
                }
              }

              if ("next" === e.method) e.sent = e._sent = e.arg;else if ("throw" === e.method) {
                if (n === l) throw n = p, e.arg;
                e.dispatchException(e.arg);
              } else "return" === e.method && e.abrupt("return", e.arg);
              n = h;
              var u = f(t, r, e);

              if ("normal" === u.type) {
                if (n = e.done ? p : s, u.arg === d) continue;
                return {
                  value: u.arg,
                  done: e.done
                };
              }

              "throw" === u.type && (n = p, e.method = "throw", e.arg = u.arg);
            }
          };
        }(t, e, c), i;
      }

      function f(t, r, e) {
        try {
          return {
            type: "normal",
            arg: t.call(r, e)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = u;
      var l = "suspendedStart",
          s = "suspendedYield",
          h = "executing",
          p = "completed",
          d = {};

      function y() {}

      function v() {}

      function m() {}

      var g = {};

      g[i] = function () {
        return this;
      };

      var w = Object.getPrototypeOf,
          b = w && w(w(S([])));
      b && b !== e && n.call(b, i) && (g = b);
      var x = m.prototype = y.prototype = Object.create(g);

      function O(t) {
        ["next", "throw", "return"].forEach(function (r) {
          t[r] = function (t) {
            return this._invoke(r, t);
          };
        });
      }

      function j(t) {
        var r;

        this._invoke = function (e, o) {
          function i() {
            return new Promise(function (r, i) {
              !function r(e, o, i, c) {
                var a = f(t[e], t, o);

                if ("throw" !== a.type) {
                  var u = a.arg,
                      l = u.value;
                  return l && "object" == typeof l && n.call(l, "__await") ? Promise.resolve(l.__await).then(function (t) {
                    r("next", t, i, c);
                  }, function (t) {
                    r("throw", t, i, c);
                  }) : Promise.resolve(l).then(function (t) {
                    u.value = t, i(u);
                  }, function (t) {
                    return r("throw", t, i, c);
                  });
                }

                c(a.arg);
              }(e, o, r, i);
            });
          }

          return r = r ? r.then(i, i) : i();
        };
      }

      function E(t, e) {
        var n = t.iterator[e.method];

        if (n === r) {
          if (e.delegate = null, "throw" === e.method) {
            if (t.iterator.return && (e.method = "return", e.arg = r, E(t, e), "throw" === e.method)) return d;
            e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return d;
        }

        var o = f(n, t.iterator, e.arg);
        if ("throw" === o.type) return e.method = "throw", e.arg = o.arg, e.delegate = null, d;
        var i = o.arg;
        return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = r), e.delegate = null, d) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, d);
      }

      function L(t) {
        var r = {
          tryLoc: t[0]
        };
        1 in t && (r.catchLoc = t[1]), 2 in t && (r.finallyLoc = t[2], r.afterLoc = t[3]), this.tryEntries.push(r);
      }

      function P(t) {
        var r = t.completion || {};
        r.type = "normal", delete r.arg, t.completion = r;
      }

      function _(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(L, this), this.reset(!0);
      }

      function S(t) {
        if (t) {
          var e = t[i];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                c = function e() {
              for (; ++o < t.length;) {
                if (n.call(t, o)) return e.value = t[o], e.done = !1, e;
              }

              return e.value = r, e.done = !0, e;
            };

            return c.next = c;
          }
        }

        return {
          next: k
        };
      }

      function k() {
        return {
          value: r,
          done: !0
        };
      }

      return v.prototype = x.constructor = m, m.constructor = v, m[a] = v.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
        var r = "function" == typeof t && t.constructor;
        return !!r && (r === v || "GeneratorFunction" === (r.displayName || r.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, m) : (t.__proto__ = m, a in t || (t[a] = "GeneratorFunction")), t.prototype = Object.create(x), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, O(j.prototype), j.prototype[c] = function () {
        return this;
      }, t.AsyncIterator = j, t.async = function (r, e, n, o) {
        var i = new j(u(r, e, n, o));
        return t.isGeneratorFunction(e) ? i : i.next().then(function (t) {
          return t.done ? t.value : i.next();
        });
      }, O(x), x[a] = "Generator", x[i] = function () {
        return this;
      }, x.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var r = [];

        for (var e in t) {
          r.push(e);
        }

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = S, _.prototype = {
        constructor: _,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(P), !t) for (var e in this) {
            "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = r);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var e = this;

          function o(n, o) {
            return a.type = "throw", a.arg = t, e.next = n, o && (e.method = "next", e.arg = r), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var c = this.tryEntries[i],
                a = c.completion;
            if ("root" === c.tryLoc) return o("end");

            if (c.tryLoc <= this.prev) {
              var u = n.call(c, "catchLoc"),
                  f = n.call(c, "finallyLoc");

              if (u && f) {
                if (this.prev < c.catchLoc) return o(c.catchLoc, !0);
                if (this.prev < c.finallyLoc) return o(c.finallyLoc);
              } else if (u) {
                if (this.prev < c.catchLoc) return o(c.catchLoc, !0);
              } else {
                if (!f) throw new Error("try statement without catch or finally");
                if (this.prev < c.finallyLoc) return o(c.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, r) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var o = this.tryEntries[e];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === t || "continue" === t) && i.tryLoc <= r && r <= i.finallyLoc && (i = null);
          var c = i ? i.completion : {};
          return c.type = t, c.arg = r, i ? (this.method = "next", this.next = i.finallyLoc, d) : this.complete(c);
        },
        complete: function complete(t, r) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), d;
        },
        finish: function finish(t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var e = this.tryEntries[r];
            if (e.finallyLoc === t) return this.complete(e.completion, e.afterLoc), P(e), d;
          }
        },
        catch: function _catch(t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var e = this.tryEntries[r];

            if (e.tryLoc === t) {
              var n = e.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                P(e);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, e, n) {
          return this.delegate = {
            iterator: S(t),
            resultName: e,
            nextLoc: n
          }, "next" === this.method && (this.arg = r), d;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = n;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (t, r) {
    t.exports = function (t) {
      if (Array.isArray(t)) {
        for (var r = 0, e = new Array(t.length); r < t.length; r++) {
          e[r] = t[r];
        }

        return e;
      }
    };
  }, function (t, r) {
    t.exports = function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    };
  }, function (t, r) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    };
  }, function (t, r) {
    t.exports = function (t) {
      if (Array.isArray(t)) return t;
    };
  }, function (t, r) {
    t.exports = function (t, r) {
      var e = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var c, a = t[Symbol.iterator](); !(n = (c = a.next()).done) && (e.push(c.value), !r || e.length !== r); n = !0) {
          ;
        }
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          n || null == a.return || a.return();
        } finally {
          if (o) throw i;
        }
      }

      return e;
    };
  }, function (t, r) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }]);
});